export default {
  "/sounds/clickb1.mp3": {
    "src": "/sounds/clickb1.mp3",
    "volume": 1
  },
  "/sounds/clickb2.mp3": {
    "src": "/sounds/clickb2.mp3",
    "volume": 1
  },
  "/sounds/clickb3.mp3": {
    "src": "/sounds/clickb3.mp3",
    "volume": 1
  },
  "/sounds/clickb4.mp3": {
    "src": "/sounds/clickb4.mp3",
    "volume": 1
  },
  "/sounds/clickb5.mp3": {
    "src": "/sounds/clickb5.mp3",
    "volume": 1
  },
  "/sounds/clickb6.mp3": {
    "src": "/sounds/clickb6.mp3",
    "volume": 1
  },
  "/sounds/clickb7.mp3": {
    "src": "/sounds/clickb7.mp3",
    "volume": 1
  },
  "scan": true
}